import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import AdminApprovalRenderer from 'timeSheet/components/CellRenderers/AdminApprovalRenderer';

const useApprovedByColumn = ({ mappedAdmins }) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return AdminApprovalRenderer({
        rowData: params.data,
        columnData: { mappedAdmins }
      });
    },
    [mappedAdmins]
  );

  return useMemo(
    () => ({
      field: 'adminApproved.adminId',
      headerName: t('approvedBy'),
      initialHide: true,
      sortable: false,
      cellClass: 'justify-start',
      width: 140,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useApprovedByColumn;
